// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__nXDsc","label":"Section_label__BPoG1","contentWrap":"Section_contentWrap__uhDcU","footer":"Section_footer__30fsQ","footerInner":"Section_footerInner__1JhWJ"};